import theme from 'src/theme/theme';
import useMediaQuery from './useMediaQuery';

export const useIsMobile = () => {
  const smallBreakpoint = theme.newBreakpoints.narrow;
  const isMobile = useMediaQuery(`(max-width: ${smallBreakpoint}px)`);

  return isMobile;
};
